import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../../Context/UserContext";
import MyInput from "../../../../Reusable/MyInput";
import Button from "../../../../Reusable/Button";
import DivisionPageForm from "../../../../masterFormPages/DivisionPageForm";
import toast from "react-hot-toast";
import { BaseURL } from "../../../../Reusable/BaseURL";
import RGPPageForm from "./NRGPPageForm";
import { NRGPpartySelect, RGPpartySelect } from "./NRGPpartySelect";
import MyTextarea from "../../../../Reusable/MyTextarea";
import RGPsearch from "./NRGPsearch";
import NRGPsearch from "./NRGPsearch";
import NRGPPageForm from "./NRGPPageForm";
import { useNavigate } from "react-router-dom";

export default function NRGP() {
  const { darkTheme, loginData } = useContext(UserContext);
  const [party, setParty] = useState("");
  const [issueDate, setIssueDate] = useState("");
  const [expecRetrDate, setExpecRetrDate] = useState("");
  const [remark, setRemark] = useState("");
  const [mergeDataArr, setMergeDataArr] = useState([]);

  const [divisionName, setDivisionName] = useState("");

  const [links, setLinks] = useState([]);
  const [firstPage, setFirstPage] = useState([]);
  const [totalNo, setTotalNo] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [getId, setGetId] = useState(0);
  const [spinner, setSpinner] = useState(true);
  const [submitAction, setSubmitAction] = useState("submit");

  // disabled action
  const [submitDisable, setSubmitDisable] = useState(false);
  const [updateDisable, setUpdateDisable] = useState(false);
  const [editDisable, setEditDisable] = useState(false);
  const navigate = useNavigate();

  // TODAY CURRENT DATE DEFAULT SET

  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
    setIssueDate(formattedDate);
  }, []);

  // useEffect(() => {
  //   ();
  // }, [issueDate]);

  // create Division
  async function createDivision(e) {
    e.preventDefault();
    // const formData = new FormData();
    // formData.append("name", divisionName);
    const arrData = mergeDataArr.map((item) => ({
      id: item.id,
      // qty: item.qty,
      qty: item.actualAvlQty,
    }));
    if (arrData?.length <= 0) {
      return toast.error("Add items before to submit!");
    }
    setSubmitDisable(true);

    const formData = {
      party_id: party.value || "",
      issue_date: issueDate || "",
      // erd: expecRetrDate,
      remarks: remark || "",
      stocks: arrData,
    };

    const res = await fetch(`${BaseURL}/purchase/nrgp/create`, {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        // Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          firstPageList();
          toast.success("Success");
          navigate("/purchase/pending-nrgp");
          setMergeDataArr([]);
          setIssueDate("");
          setParty("");
          setRemark("");
          setDivisionName("");
          setSubmitDisable(false);
        } else {
          setSubmitDisable(false);
        }
        if (createRes?.error?.message?.party_id) {
          toast.error(createRes.error.message.party_id);
        }
        if (createRes?.error?.message?.issue_date) {
          toast.error(createRes.error.message.issue_date);
        } else if (createRes?.error?.message) {
          toast.error("Some Issue !");
        }
      });
  }

  // Listing record
  function firstPageList(url = `${BaseURL}/divisions?page=1`) {
    setSpinner(true);
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((divisionList) => {
        if (divisionList?.status) {
          const revData = divisionList.data.data.reverse();
          setFirstPage(revData);
          setTotalNo(divisionList.data.total);
          setLinks(divisionList.data.links);
          setFrom(divisionList.data.from);
          setTo(divisionList.data.to);
          setSpinner(false);
        }
      });
  }

  function editBtn(editData) {
    setEditDisable(true);
    setSubmitAction("update");
    setDivisionName(editData.name || "");
    setEditDisable(false);
  }
  // UPDATE A RECORD
  async function updateARecord(e, id) {
    e.preventDefault();
    setUpdateDisable(true);
    const formData = { name: divisionName };
    const updRes = await fetch(`${BaseURL}/divisions/${id}`, {
      method: "PATCH",
      body: JSON.stringify(formData),
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      // body: JSON.stringify({name: divisionName}),
    })
      .then((res) => res.json())
      .then((upd) => {
        if (upd.status) {
          firstPageList();
          setGetId(0);
          toast.success("Updated");
          setDivisionName("");
          setSubmitAction("submit");
          setUpdateDisable(false);
        }
        if (upd.status === false) {
          setUpdateDisable(false);
        }
        if (upd?.error?.message.name) {
          toast.error(upd.error.message.name);
        }
      });
  }

  function cancelFun() {
    setSubmitAction("submit");
    setDivisionName("");
    setGetId(0);
    setUpdateDisable(false);
    setSubmitDisable(false);
    setEditDisable(false);
  }

  return (
    <div
      className={`p-2 pb-8 rounded-xl text-sm ${
        darkTheme ? "bg-slate-600" : "bg-slate-100"
      }`}
    >
      <div>
        <div>
          <div
            className={`font-[600] text-sm uppercase text-center my-2 border-b bg-[#b4a996] py-1 mb-4 rounded-tr-lg rounded-tl-lg ${
              darkTheme ? "border-b-slate-700" : "border-b-slate-200"
            }`}
          >
            NRGP
          </div>
          <div
            // className="grid grid-cols-1 gap-8 md:gap-1 lg:gap-4 md:grid-cols-2"
            className="flex flex-col justify-between gap-8 md:gap-1 lg:gap-4"
          >
            <div className="w-full px-2">
              <form
                action=""
                className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-2 md:gap-3"
              >
                <div className="mb-2 w-full">
                  <label>
                    Party <span className="text-red-500 font-bold">*</span>
                  </label>
                  <NRGPpartySelect
                    selectedOption={party}
                    setSelectedOption={setParty}
                  />
                </div>

                <MyTextarea
                  label="Remark"
                  type="text"
                  className="w-full"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                />
                <div className="grid grid-cols-1 gap-2 md:gap-3 md:grid-cols-2">
                  <div className="mb-2 w-full">
                    <label className="mr-2 block mb-[4px]">
                      Issue Date{" "}
                      <span className="text-red-500 font-bold">*</span>
                    </label>
                    <input
                      className={`py-1.5 rounded-lg px-2 md:px-3 outline-none border ${
                        darkTheme
                          ? "bg-gray-700 border-gray-500"
                          : "bg-white border-gray-500"
                      }`}
                      value={issueDate}
                      onChange={(e) => setIssueDate(e.target.value)}
                      type="date"
                      name="date"
                    />
                  </div>
                  {/* <div className="mb-2 w-full">
                    <label className="mr-2 block mb-[4px]">
                      Expe Return D{" "}
                      <span className="text-red-500 font-bold">*</span>
                    </label>
                    <input
                      className={`py-1.5 rounded-lg px-2 md:px-3 outline-none border ${
                        darkTheme
                          ? "bg-gray-700 border-gray-500"
                          : "bg-white border-gray-500"
                      }`}
                      value={expecRetrDate}
                      onChange={(e) => setExpecRetrDate(e.target.value)}
                      type="date"
                      name="date"
                    />
                  </div> */}
                </div>
              </form>
            </div>

            <NRGPsearch
              mergeDataArr={mergeDataArr}
              setMergeDataArr={setMergeDataArr}
            />

            <div className="w-full px-2">
              <NRGPPageForm
                editBtn={editBtn}
                firstPageList={firstPageList}
                links={links}
                firstPage={mergeDataArr}
                setFirstPage={setMergeDataArr}
                setGetId={setGetId}
                spinner={spinner}
                totalNo={totalNo}
                from={from}
                to={to}
                editDisable={editDisable}
              />
            </div>
          </div>
          {submitAction === "submit" && (
            <div className="flex items-center justify-center gap-x-1 mt-3">
              <Button
                disabled={submitDisable}
                type="submit"
                onClick={(e) => createDivision(e)}
              >
                {submitDisable ? "Wait.." : "Submit"}
              </Button>
              <Button type="button" onClick={() => cancelFun()}>
                Clear
              </Button>
            </div>
          )}
          {/* {submitAction === "update" && (
            <div className="flex items-center justify-start gap-x-1 mt-3">
              <Button
                disabled={updateDisable}
                type="submit"
                onClick={(e) => updateARecord(e, getId)}
              >
                {updateDisable ? "Wait.." : "Update"}
              </Button>
              <Button onClick={() => cancelFun()} type="button">
                Cancel
              </Button>
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
}
